<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Cartão Digital
    </h1>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="content__main__page" *ngIf="!loadingCosts; else showLoading">
    <section class="content__header">
        <h3>
            Minhas Carteirinhas
        </h3>
    </section>
    <section class="content__main">
        <div class="d-flex content__header__table">
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1">
                <div class="form-check text-center">
                    <input class="form-check-input position-static" name="carteirinhas"
                        (click)="selecionarTodasCarteirinhas()" type="checkbox">
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-5">Nome</div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3">Convênio</div>
            <div class="col-xl-3 col-lg-3 col-md-3 display-sm-none">Número do cartão</div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 text-center">Ações</div>
        </div>
        <div class="table__card" *ngFor="let cartao of cartoes">
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1" id="checkBoxCarteirinhas">
                <div class="form-check text-center">
                    <input class="form-check-input position-static" name="carteirinhas"
                        value="{{cartao.convenio}}-{{cartao.cpf}}" type="checkbox">
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-5">{{ cartao.nome }}</div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3">{{ cartao.convenio | uppercase }}</div>
            <div class="col-xl-3 col-lg-3 col-md-3 display-sm-none">{{ cartao.numero_Cartao }}</div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 icon__button">
                <a class="table__card__button__action" (click)="downloadCarteirinha(cartao.link)">
                    <fa-icon [icon]="faDownload"></fa-icon>
                </a>
                <a class="table__card__button__action" (click)="open(cartao.link)">
                    <fa-icon [icon]="faEye"></fa-icon>
                </a>
                <a class="table__card__button__action" (click)="prints(cartao.link)">
                    <fa-icon [icon]="faPrint"></fa-icon>
                </a>
            </div>
        </div>
    </section>
    <div class="imprimirCarteirinhas">
        <button type="submit" class="btn button-primary" (click)="imprimirCarteirinhas()">Imprimir Selecionados</button>
    </div>
</main>
